import { Grid } from '@mui/material';
import { useContext } from 'react';
import ProjectWarningContext from '../../context/ProjectWarningContext';
import projectWarning from '../../images/project-warnings.svg';
import RiskBarDrawer from './RiskBarDrawer';
import Button from '../atoms/button';

const RiskBar = () => {
  const { showRiskBar, dispatch } = useContext(ProjectWarningContext);
  const handledClick = async () => {
    await dispatch({
      type: 'SHOW_RISK_BAR',
      payload: {
        showRiskBar: !showRiskBar,
      },
    });
  };

  return (
    <Grid container>
      {!showRiskBar ? (
        <Button primary outlinedColor icon onClick={handledClick}>
          <img width={24} height={24} src={projectWarning} alt="alerts" />
        </Button>
      ) : (
        <>
          <Button primary icon onClick={handledClick}>
            <img width={24} height={24} src={projectWarning} alt="alerts" />
          </Button>
          <RiskBarDrawer />
        </>
      )}
    </Grid>
  );
};

export default RiskBar;
